import React from 'react';
import { useTranslation } from 'react-i18next';
import isNil from 'lodash/isNil';
import noop from 'lodash/noop';
import { observer } from 'mobx-react-lite';
import { Onboarding, Tooltip } from '@web-chat-core/ui-kit';
import { selectSomeoneStartedSummary, selectUser } from 'state/selectors';
import { SummaryButtonLayout, SummaryIcon } from './view';

const onboardingSteps = [
    {
        target: '[data-id="startSummaryButton"]',
        titlei18nKey: 'videoconference_AI_Assistant_turned_on',
        descriptioni18nKey: 'web_videoconference_AI_Assistant_onbording_description',
        confirmi18nKey: 'web_videoconference_AI_Assistant_onbording_button',
    },
];
interface Props {
    onClick(): void;
    isMobile?: boolean;
}

export const StartSummaryButton: React.FC<Props> = observer(({ onClick, isMobile }) => {
    const { t } = useTranslation();
    const user = selectUser();
    const isUserInfoExists = !isNil(user);

    const disabled = !isUserInfoExists;
    const onClickHandler = isUserInfoExists ? onClick : noop;
    const tooltip = isUserInfoExists
        ? t('web_videoconference_AI_Assistant_turn_on_tooltip_button')
        : t('videoconference_AI_Assistant_guest_turned_on');

    const someoneStartedSummary = selectSomeoneStartedSummary();

    return (
        <>
            {someoneStartedSummary && (
                <Onboarding isShowOnce={false} steps={onboardingSteps} storageKey="AI_Assistant_start" />
            )}
            <Tooltip label={tooltip}>
                <SummaryButtonLayout
                    disabled={disabled}
                    onClick={onClickHandler}
                    data-id="startSummaryButton"
                    $isMobile={isMobile}
                >
                    <SummaryIcon $isActive={disabled} icon="icAINotes" size={24} />
                </SummaryButtonLayout>
            </Tooltip>
        </>
    );
});
